import { init as coreInit } from '../../core/js/components/coreComponent';
import { init as productInit } from './components/productComponent';

import { configureStore } from './store';
import productStartingSagas from './init/productStartingSagas';
import { quickshopSagasInitialized } from './actions/quickshopActions';

import { launchSizeGuideOnPageLoad } from './utils/sizeGuideUtils';

const store = configureStore();

productStartingSagas.forEach((saga) => {
    store.runSaga(saga);
});

// product & quickshop share the same sagas
// prevent async quickshop from re-running the same sagas
store.dispatch(quickshopSagasInitialized(true));

const productRegistry = productInit(store);
const coreRegistry = coreInit(store);

window.__store = store;

if (window.isSizeGuideWebview) {
    launchSizeGuideOnPageLoad('LAUNCH_SIZEGUIDE');
}
